import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../Firebase';
import progressBar from '../../assets/polls/progress_bar_stats.svg';
import Chart from "react-apexcharts";
import Tooltip from '@material-ui/core/Tooltip';
import editImage from '../../assets/pencil.svg';

import "./DisplayStatsAnswers.css";

class DisplayStatsContent extends Component {

    render() {
        return (
            <DisplayStats />
        );
    }

}

const INITIAL_STATE = {
    countConstellation: {},
    countCosmos: {},
    totalConstellation: 0,
    totalCosmos: 0,
    totalAnswers: 0,
    currentUserId: '',
    error: null,
};

class DisplayStatsBase extends Component {

    constructor(props) {
        super(props);
        this.state = { ...INITIAL_STATE };
    }

    componentDidMount = async () => {

        this.props.firebase.auth.onAuthStateChanged(async (currentUser) => {

            if (currentUser === null) {
                return
            }
            const activeCapsuleID = this.props.activeCapsuleID;
            const activePollID = this.props.activePollID;

            let answers = await this.props.firebase.db.collection('capsules')
                .doc(activeCapsuleID)
                .collection('polls')
                .doc(activePollID)
                .collection('userAnswers')
                .get()

            let querySnapshotUsers = await this.props.firebase.db.collection('users').get();
            const currentUserManager = querySnapshotUsers.docs
                .filter(user => user.id === currentUser.uid)
                .map(doc => doc.data().manager)[0];
            const team = querySnapshotUsers.docs
                .filter(doc => doc.data().manager === currentUser.uid)
                .map(doc => doc.id)
            const peers = querySnapshotUsers.docs
                .filter(doc => doc.data().manager === currentUserManager)
                .map(doc => doc.id)

            const possibleAnswers = Object.values(this.props.answers);
            let countConstellation = {}
            let countCosmos = {}
            let totalAnswers = 0
            possibleAnswers.forEach(possibleAnswer => {
                countConstellation[possibleAnswer] = 0
                countCosmos[possibleAnswer] = 0
            });
            answers.docs.forEach(answer => {
                if (team.includes(answer.data().userId)) {
                    countConstellation[answer.data().answer] += 1
                }
                else if (peers.includes(answer.data().userId)) {
                    countConstellation[answer.data().answer] += 1
                }
                countCosmos[answer.data().answer] += 1
                totalAnswers += 1
            })
            let totalConstellation = this.totalAnswers(countConstellation);
            let totalCosmos = this.totalAnswers(countCosmos);
            countConstellation = this.answersToPercents(countConstellation)
            countCosmos = this.answersToPercents(countCosmos)
            this.setState({ countConstellation, countCosmos, totalConstellation, totalCosmos, totalAnswers, currentUserId: currentUser.uid })
        })
    }

    answersToPercents(answers) {
        const totalAnswers = this.totalAnswers(answers);
        Object.keys(answers).forEach(key => {
            answers[key] = (answers[key] / totalAnswers) * 100
        })
        return answers
    }

    totalAnswers(answers) {
        return Object.values(answers).reduce((a, b) => a + b, 0);
    }

    onClick() {
        this.props.onClose();
    }

    render() {
        const { error, poll, question } = this.props;
        const creationDate = this.props.creationDate ? new Intl.DateTimeFormat('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(Number(this.props.creationDate)) : null
        const { countConstellation, countCosmos, totalConstellation, totalCosmos, totalAnswers, currentUserId } = this.state
        const options = {
            plotOptions: {
                bar: {
                    horizontal: true,
                    dataLabels: {
                        position: 'top'
                    }
                }
            },
            dataLabels: {
                enabled: true,
                offsetX: -6,
                style: {
                    fontSize: '12px',
                    colors: ['#fff']
                },
                formatter: function (val) {
                    return val + "%"
                },
            },
            stroke: {
                show: true,
                width: 1,
                colors: ['#fff']
            },
            xaxis: {
                categories: Object.keys(countConstellation).map((map, index) => "Rep. " + (index + 1)),
                labels: {
                    show: true,
                    trim: false,
                    formatter: function (val) {
                        return val + "%"
                    },
                },
                tickAmount: 1,

            },
            yaxis: {
                labels: {
                    show: true,
                    align: 'right',
                    minWidth: 0,
                    trim: false,
                    style: {
                        cssClass: 'apexcharts-yaxis-label',
                    },
                },
            },
            tooltip: {
                enabled: true,
                followCursor: true,
                x: {
                    show: true,
                },
                y: {
                    formatter: function (val, opt) {
                        let total = opt.seriesIndex === 0 ? totalConstellation : totalCosmos
                        let votes = val * total / 100
                        return "nb votes: " + `${votes}` + "<br>" + "population: " + `${total}`
                    },
                }

            }
        }
        const series = [{
            name: "Ma constellation",
            data: Object.values(countConstellation),
        },
        {
            name: "Le cosmos",
            data: Object.values(countCosmos)
        }
        ]
        return (
            <>
                <div className="display-poll-container">

                    <div className="display-poll-header">
                        <img className="display-poll-bar" src={progressBar} alt="Answer" />
                    </div>
                    <div className={window.innerWidth > 768 ? "display-body-desktop" : "display-body-mobile"}>
                        <div className="display-infos-container">
                            <Tooltip title="Editer" aria-label="editer" hidden={poll.creatorId !== currentUserId} className={window.innerWidth > 768 ? "edit-poll-desktop" : "edit-poll-mobile"}>
                                <img src={editImage} alt="edit" className="edit-icon cursor-pointer" onClick={this.props.openEdit}></img>
                            </Tooltip>
                            <div className="display-title">{question}</div>
                            <div className="display-poll-date">{creationDate}</div>
                            <div className="display-poll-answers">{totalAnswers === 1 ? totalAnswers + ' réponse' : totalAnswers + ' réponses'}</div>
                        </div>
                        <div className="display-line-mobile" hidden={window.innerWidth > 768}></div>
                        <div className={window.innerWidth > 768 ? "display-answers-container display-center" : "display-answers-container-mobile display-center"}>

                            <Chart
                                options={options}
                                series={series}
                                type="bar"
                                width="100%"
                            />
                            <div className="poll-answers">
                                {Object.keys(countConstellation).map((label, index) =>
                                    <div>
                                        <strong>{"Rep. " + (index + 1)}: </strong><span>{label}</span>
                                    </div>
                                )}
                                {error && <p>{error.message}</p>}
                            </div>

                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-center pt-2 pb-2">
                    <button type="button" onClick={this.props.onClose} className="ok-poll-button">OK</button>
                </div>
            </>
        );
    }

}

const DisplayStats = withRouter(withFirebase(DisplayStatsBase));


export default DisplayStatsContent;
export { DisplayStats };